"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _classnames = _interopRequireDefault(require("classnames"));

var _sharedCss = _interopRequireDefault(require("../../shared/oldDocumentSignerUI/sharedCss"));

var _fieldStatusClass = _interopRequireDefault(require("./fieldStatusClass"));

var _truncate = _interopRequireDefault(require("../../utilities/truncate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles(theme) {
  return _objectSpread(_objectSpread({}, _sharedCss.default.fields), {}, {
    textField: {
      position: 'absolute'
    },
    input: {
      paddingLeft: '5px',
      paddingRight: '5px'
    }
  });
};

var NumberField = function NumberField(props) {
  var id = props.id,
      name = props.name,
      x = props.x,
      y = props.y,
      height = props.height,
      width = props.width,
      handleChange = props.handleChange,
      classes = props.classes,
      _props$value = props.value,
      value = _props$value === void 0 ? '' : _props$value,
      setFieldRef = props.setFieldRef,
      max = props.max,
      _props$_derived = props._derived,
      isRequired = _props$_derived.isRequired,
      isDisabled = _props$_derived.isDisabled;
  var fieldDynamicStyle = {
    top: y,
    left: x,
    height: height,
    width: width
  };
  var inputClass = (0, _classnames.default)(classes.input, (0, _fieldStatusClass.default)(props));

  var onChange = function onChange(_ref) {
    var value = _ref.target.value;
    value = "".concat(value).replace(/[^0-9.-]+/g, '');
    value = (0, _truncate.default)(value, max);
    handleChange(value);
  };

  return /*#__PURE__*/_react.default.createElement(_TextField.default, {
    id: name,
    inputRef: function inputRef(e) {
      return setFieldRef(e, y);
    },
    inputMode: "numeric",
    pattern: "[0-9]*",
    className: classes.textField,
    value: value === null || value === undefined ? '' : value,
    style: fieldDynamicStyle,
    type: "text",
    onChange: onChange,
    margin: "none",
    disabled: isDisabled,
    "data-test-id": "NumberField-root-".concat(id),
    placeholder: isRequired ? 'Required' : '',
    InputProps: {
      disableUnderline: isDisabled,
      classes: {
        input: inputClass
      },
      inputProps: {
        'data-test-id': "NumberField-input-".concat(id)
      }
    }
  });
};

var _default = (0, _styles.withStyles)(styles)(NumberField);

exports.default = _default;